import React from 'react';
import { getEntity, getMitigatingControls, isKevExploited } from '../../lib/selectors';
import { normaliseAttackId } from '../../lib/attack-ids';
import KevBadge from './KevBadge';

// Threat panel (prototype right column). ATT&CK techniques as left-oxblood rows
// with a severity dot, tactic metadata and a KEV marker. Relationship states:
// selected glows oxblood; when a control is selected, the techniques it mitigates
// are `linked` (coral, "mitigated by"); unmapped techniques show a "no control" gap.
const TTPList = ({ ttps, selectedTTP, onTTPSelect, renderText, title, hint, highlightAnchorIds = null }) => {
  return (
    <div className="tv-panel">
      <h2>
        <span className="tv-ph-dot" style={{ background: 'var(--tv-threat)' }} />
        {title || 'Adversary Techniques — Threat'}
      </h2>
      <p className="tv-hint">{hint}</p>

      {ttps.length === 0 ? (
        <p className="tv-empty">No techniques match the current filter.</p>
      ) : (
        ttps.map((ttp) => {
          const anchorId = normaliseAttackId(ttp);
          const entity = getEntity(anchorId);
          const name = entity?.name || ttp;
          const tactic = Array.isArray(entity?.metadata?.tactics)
            ? entity.metadata.tactics.join(' · ')
            : '';
          const kev = isKevExploited(anchorId);
          const gap = getMitigatingControls(anchorId).length === 0;
          const sev = kev && gap ? 'crit' : kev ? 'high' : gap ? 'med' : 'low';
          const kind = entity?.kind === 'risk' ? 'risk' : 'thr';

          const sel = selectedTTP === ttp;
          const linked = highlightAnchorIds && highlightAnchorIds.has(anchorId);
          const dimmed = highlightAnchorIds && !linked && !sel;
          const cls = ['tv-row', kind, sel ? 'sel' : '', linked ? 'linked' : '', dimmed ? 'dim' : ''].join(' ');

          return (
            <button key={ttp} className={cls} onClick={() => onTTPSelect(ttp)}>
              <span className={`tv-sev ${sev}`} />
              <span style={{ flex: 1 }}>
                <span className="tv-rid">{renderText ? renderText(ttp) : ttp}</span>
                <div className="tv-rn">{renderText ? renderText(name) : name}</div>
                {tactic && <div className="tv-rmeta">{tactic}</div>}
              </span>
              <span style={{ marginLeft: 'auto', display: 'flex', gap: 6, alignItems: 'center' }}>
                {kev && <KevBadge compact />}
                {linked ? (
                  <span className="tv-link-tag">mitigated by</span>
                ) : gap ? (
                  <span className="tv-gap-tag">no control</span>
                ) : null}
              </span>
            </button>
          );
        })
      )}
    </div>
  );
};

export default TTPList;
